var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['m-menu']},[_c('span',{class:_vm.$style.trigger,on:{"click":function($event){$event.stopPropagation();return _vm.toggleMenu($event)}}}),(_vm.showMobileMenu)?_c('DropDwonMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }